<template>
  <div>
    <div>
      <form-wizard
        @on-complete="saveInvestor"
        @on-change="scrollToTop"
        title
        subtitle
        color="#8cc63f"
        finish-button-text="Submit"
        shape="square"
      >
        <tab-content title="Personal Details" icon="ti-id-badge">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8">
              <label v-if="formType == 'update'"> {{ code }}</label>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Title</label>
              <select class="custom-select" v-model="title">
                <option
                  v-for="title in titleList"
                  :key="title.name"
                  :value="title.name"
                >
                  {{ title.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>First Name</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="first_name"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Last Name</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="last_name"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Gender</label>
              <select class="custom-select" v-model="gender">
                <option
                  v-for="gender in genderList"
                  :key="gender.name"
                  :value="gender.id"
                >
                  {{ gender.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Nationality</label>
              <select class="custom-select" v-model="nationality_id">
                <option
                  v-for="nationality in countries"
                  :key="nationality.name"
                  :value="nationality.id"
                >
                  {{ nationality.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Country of Residence</label>
              <select class="custom-select" v-model="country_of_residence_id">
                <option
                  v-for="nationality in countries"
                  :key="nationality.name"
                  :value="nationality.id"
                >
                  {{ nationality.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Address</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="home_address"
              />
            </div>
            <div class="col-8" style="margin-top: 15px; text-align: center">
              <div>Birth Date</div>
              <b-calendar
                show-decade-nav
                v-model="date_of_birth"
                locale="en-US"
              ></b-calendar>
            </div>
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Status</label>
              <select class="custom-select" v-model="status">
                <option
                  v-for="status in statusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div> -->
            <div class="col-8" style="margin-top: 15px">
              <label>Marital Status</label>
              <select class="custom-select" v-model="marital_status">
                <option
                  v-for="status in maritalStatusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Passport/National ID</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="pasport_id"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-around;
                "
              >
                <label class="form-label" for="customFile"
                  >Passport/National ID Media</label
                >
                <div v-if="!passport_image">
                  <media-browser
                    filterBy="images"
                    v-model="passport_image"
                    :active="showMediaBrowserModal"
                    @closeRequest="toggleMediaBrowserModal"
                  ></media-browser>
                  <i
                    @click="toggleMediaBrowserModal"
                    style="font-size: 170px"
                    class="fa fa-image"
                  ></i>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                  v-else
                >
                  <img
                    :src="
                      'data:image/' +
                      passport_image.extension +
                      ';base64,' +
                      passport_image.image
                    "
                    alt=""
                  />

                  <div style="margin-top: 15px">
                    <button
                      style="
                        border-radius: 30px;
                        padding-top: 0px;
                        padding-left: 7px;
                        padding-right: 7px;
                        padding-bottom: 0px;
                      "
                      @click="removePassportImage()"
                      type="button"
                      class="btn btn-danger"
                    >
                      <i style="font-size: 12px" class="fa fa-trash"></i>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content
          v-if="formType == 'create'"
          title="Contract Details"
          icon="ti-receipt"
        >
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="margin-top: 10px; display: flex">
              <span style="margin-right: 5px" for="with_contract"
                >Create Contract For Investor?</span
              >
              <input
                id="with_contract"
                v-model="with_contract"
                type="checkbox"
                style="height: 20px; width: 20px"
              />
            </div>
          </div>
          <div
            v-if="with_contract"
            style="
              display: flex;
              align-items: center;
              margin-top: 20px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="margin-top: 15px">
              <label>Contract Status</label>
              <select class="custom-select" v-model="status">
                <option
                  v-for="status in statusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Contract Length</label>
              <select class="custom-select" v-model="investor_status">
                <option
                  v-for="status in statusList"
                  :key="status.name"
                  :value="status.id"
                >
                  {{ status.name }}
                </option>
              </select>
            </div> -->
            <div
              class="col-8"
              style="
                display: flex;
                justify-content: space-around;
                margin-top: 20px;
              "
            >
              <div>
                <div>Start Date</div>
                <b-calendar
                  show-decade-nav
                  v-model="start_date"
                  locale="en-US"
                ></b-calendar>
              </div>
              <div>
                <div>End Date</div>
                <b-calendar
                  show-decade-nav
                  v-model="maturity_date"
                  locale="en-US"
                ></b-calendar>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Plan</label>
              <select class="custom-select" v-model="plan_id">
                <option v-for="plan in plans" :key="plan.name" :value="plan.id">
                  {{ plan.name }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Currency</label>
              <select class="custom-select" v-model="currency_id">
                <option
                  v-for="currency in currencies"
                  :key="currency.code"
                  :value="currency.id"
                >
                  {{ currency.code }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Initial Investment</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="invested_principal"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Payment Type</label>
              <select class="custom-select" v-model="payment_type">
                <option
                  v-for="type in paymentTypes"
                  :key="type.name"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Earnings Rate</label>
              <input class="form-control" type="text" required v-model="name" />
            </div> -->
            <!-- <div class="col-8" style="margin-top: 15px">
              <label>Description</label>
              <textarea
                class="form-control"
                type="text"
                required
                v-model="description"
              />
            </div> -->
          </div>
        </tab-content>
        <tab-content title="Contact Info" icon="ti-credit-card">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8" style="margin-top: 15px">
              <label>Phone Number</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="mobile_number"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Email</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="email"
              />
            </div>
            <div class="col-8" style="margin-top: 25px">
              <label style="font-size: 18px">Mailing Address</label>
            </div>
            <div class="col-8" style="margin-top: 10px; display: flex">
              <span style="margin-right: 5px" for="as_mail_address"
                >Same as Home Address</span
              >
              <input
                id="as_mail_address"
                v-model="as_home_address"
                type="checkbox"
                style="height: 20px; width: 20px"
              />
            </div>
            <div v-if="!as_home_address" class="col-8" style="margin-top: 15px">
              <input
                class="form-control"
                type="text"
                required
                v-model="mailing_address"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Emergency Contact Name</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="emergency_contact_name"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Emergency Contact Relation</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="emergency_contact_relation"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Emergency Contact Phone Number</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="emergency_contact_number"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Emergency Contact Email Address</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="emergency_contact_email"
              />
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import InvestorStorer from "../../../../storers/StoreInvestor";
import UserStorer from "../../../../storers/StoreUser";
import InvestorAccountStorer from "../../../../storers/StoreInvestorAccount";
import InvestorContractStorer from "../../../../storers/StoreInvestorContract";
import InvestorsFilter from "../../../../filters/InvestorsFilter";
import { mapState } from "vuex";
import MediaBrowser from "../../../common/MediaBrowser.vue";

export default {
  props: ["formType", "activeInvestorID"],
  data() {
    return {
      titleList: [{ name: "Mr." }, { name: "Ms." }],
      genderList: [
        { id: 0, name: "Male" },
        { id: 1, name: "Female" },
        { id: null, name: "Other" },
      ],
      maritalStatusList: [
        { id: "single", name: "Single" },
        { id: "married", name: "Married" },
        { id: "divorced", name: "Divorced" },
        { id: "widowed", name: "Widowed" },
      ],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      paymentTypes: [
        { id: "cash", name: "Cash" },
        { id: "banktransfer", name: "Bank Transfer" },
        { id: "cheque", name: "Cheque" },
        { id: "blockchain", name: "Blockchain" },
      ],
      showMediaBrowserModal: false,
      as_home_address: false,
      with_contract: true,
      // User Details
      email: null,

      // Investor Details
      code: null,
      title: null,
      first_name: null,
      last_name: null,
      home_address: null,
      mailing_address: null,
      mobile_number: null,
      date_of_birth: null,
      gender: null,
      marital_status: null,
      nationality_id: null,
      country_of_residence_id: null,
      profile_picture: null,
      pasport_id: null,
      passport_image: null,
      emergency_contact_name: null,
      emergency_contact_number: null,
      emergency_contact_relation: null,
      emergency_contact_email: null,

      // Contract Details
      plan_id: null,
      invested_principal: null,
      currency_id: null,
      payment_type: null,
      start_date: null,
      maturity_date: null,
      signature_image: null,
      status: null,
    };
  },
  components: { MediaBrowser },
  created: function () {
    this.$store.dispatch("searchCountries");
    this.$store.dispatch("searchCurrencies");
    this.$store.dispatch("searchPlans");
    if (this.formType == "update") {
      var investorsFilter = InvestorsFilter();
      investorsFilter.ids = [this.activeInvestorID];
      investorsFilter.with = ["user"];
      this.$store
        .dispatch("searchInvestors", {
          filter: investorsFilter,
          resultMode: "default",
        })
        .then(() => {
          this.fillForm();
        });
    }
  },
  computed: {
    ...mapState({
      plans: (state) => state.planStore.planSearch.plans,
      countries: (state) => state.countryStore.countrySearch.countries,
      currencies: (state) => state.currencyStore.currencySearch.currencies,
      investors: (state) => state.investorStore.investorSearch.investors,
      contracts: (state) => state.contractStore.contractSearch.contracts,
      activeInvestor: (state) =>
        state.investorStore.investorSearch.investors[0],
    }),
  },
  methods: {
    init() {
      this.as_home_address = false;
      // User Details
      this.email = null;

      // Investor Details
      this.first_name = null;
      this.last_name = null;
      this.home_address = null;
      this.mailing_address = null;
      this.mobile_number = null;
      this.date_of_birth = null;
      this.gender = null;
      this.marital_status = null;
      this.nationality_id = null;
      this.country_of_residence_id = null;
      this.profile_picture = null;
      this.pasport_id = null;
      this.passport_image = null;
      this.emergency_contact_name = null;
      this.emergency_contact_number = null;
      this.emergency_contact_relation = null;
      this.emergency_contact_email = null;

      this.plan_id = null;
      this.invested_principal = null;
      this.currency_id = null;
      this.payment_type = null;
      this.start_date = null;
      this.maturity_date = null;
      this.signature_image = null;
      this.status = null;
    },
    fillForm() {
      if (this.home_address == this.mailing_address) {
        this.as_home_address = true;
      }
      // User Details
      this.email = this.activeInvestor.user.email;

      // Investor Details
      this.code = this.activeInvestor.code;
      this.title = this.activeInvestor.title;
      this.first_name = this.activeInvestor.first_name;
      this.last_name = this.activeInvestor.last_name;
      this.home_address = this.activeInvestor.home_address;
      this.mailing_address = this.activeInvestor.mailing_address;
      this.mobile_number = this.activeInvestor.mobile_number;
      this.date_of_birth = this.activeInvestor.date_of_birth;
      this.gender = this.activeInvestor.gender;
      this.marital_status = this.activeInvestor.marital_status;
      this.nationality_id = this.activeInvestor.nationality_id;
      this.country_of_residence_id =
        this.activeInvestor.country_of_residence_id;
      this.profile_picture = this.activeInvestor.profile_picture;
      this.pasport_id = this.activeInvestor.pasport_id;
      this.passport_image = this.activeInvestor.passport_image;
      this.emergency_contact_name = this.activeInvestor.emergency_contact_name;
      this.emergency_contact_number =
        this.activeInvestor.emergency_contact_number;
      this.emergency_contact_relation =
        this.activeInvestor.emergency_contact_relation;
      this.emergency_contact_email =
        this.activeInvestor.emergency_contact_email;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    toggleMediaBrowserModal() {
      this.showMediaBrowserModal = !this.showMediaBrowserModal;
    },

    removePassportImage() {
      this.passport_image = null;
    },

    saveInvestor() {
      var investor = InvestorStorer();
      var user = UserStorer();
      var investorAccount = InvestorAccountStorer();

      if (this.formType == "update") {
        investor.id = this.activeInvestor.id;
        investor.code = this.activeInvestor.code;
      }
      // Investor Details
      investor.title = this.title;
      investor.first_name = this.first_name;
      investor.last_name = this.last_name;
      investor.home_address = this.home_address;
      if (this.as_home_address) {
        investor.mailing_address = this.home_address;
      } else {
        investor.mailing_address = this.mailing_address;
      }
      investor.mobile_number = this.mobile_number;
      investor.date_of_birth = this.date_of_birth;
      investor.gender = this.gender;
      investor.marital_status = this.marital_status;
      investor.nationality_id = this.nationality_id;
      investor.country_of_residence_id = this.country_of_residence_id;
      investor.profile_picture = this.profile_picture;
      investor.pasport_id = this.pasport_id;
      if (this.passport_image) {
        investor.passport_image_id = this.passport_image.id;
      }
      investor.emergency_contact_name = this.emergency_contact_name;
      investor.emergency_contact_number = this.emergency_contact_number;
      investor.emergency_contact_relation = this.emergency_contact_relation;
      investor.emergency_contact_email = this.emergency_contact_email;

      user.email = this.email;
      user.userable_type = "investor";

      investor.user = user;

      // Investor Details
      if (this.with_contract) {
        var contract = InvestorContractStorer();
        contract.status = this.status;
        contract.plan_id = this.plan_id;
        contract.invested_principal = this.invested_principal;
        contract.currency_id = this.currency_id;
        contract.payment_type = this.payment_type;
        contract.start_date = this.start_date;
        contract.maturity_date = this.maturity_date;
        if (this.signature_image) {
          contract.signature_image_id = this.signature_image.id;
        }
        investorAccount.initial_balance = this.invested_principal;
        investorAccount.net_balance = this.invested_principal;
        investorAccount.currency_id = this.currency_id;
        investor.investorAccount = investorAccount;
        investor.contract = contract;
      } else {
        var usdCurrency = this.currencies.find((currency) => {
          return currency.code == "USD";
        });
        investorAccount.initial_balance = 0;
        investorAccount.net_balance = 0;
        investorAccount.currency_id = usdCurrency.id;
        investor.investorAccount = investorAccount;
      }
      this.$emit("saveInvestor", investor);
    },
  },
};
</script>
<style>
.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 30px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 20px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/forms/investorForm.vue